module.exports = __webpack_public_path__ + "c002f01f4c3efa9a01b836391b3362a0.MP3";